import { FIRE_ALERT_AUDIO } from '../_constants';
import { createChimeAudio } from './chimeAudio';

const audioContext: AudioContext = new (window.AudioContext || (window as any).webkitAudioContext)();

// Alert 신호를 받으면 경고음 재생
export function playAlertSound() {
  // 브라우저의 자동 재생 차단을 우회하기 위해 AudioContext가 'suspended' 상태이면 resume() 실행
  if (audioContext.state === 'suspended') {
    audioContext.resume(); // 자동 재생 정책 우회
  }
  // 경고음은 방송 시작음과 같은 음원이므로 createChimeAudio 로 만들어
  // 방송 쪽 요청과 같은 모드로 같은 캐시 항목을 공유하게 한다
  const alertSound = createChimeAudio(FIRE_ALERT_AUDIO); // 경고음 파일
  alertSound.play().catch((error) => console.error('Audio play failed:', error));
}
